/**
 * Chaves do localStorage que guardam dado financeiro.
 *
 * Ficam num arquivo só porque a lista tem um dono: `ModernDashboard` apaga
 * TODAS elas na troca de usuário e no logout. O link do produto é público e a
 * mesma máquina é usada por pessoas diferentes — uma chave nova que não entre
 * nesta lista vaza o dado de um usuário para o próximo, em silêncio.
 */

export const CHAVE_DRE = 'dashboard_dreData';
export const CHAVE_BALANCO = 'dashboard_balancoData';
export const CHAVE_DASHBOARD = 'dashboard_dashboardData';
export const CHAVE_ARQUIVOS = 'dashboard_uploadedFiles';
export const CHAVE_ULTIMO_SALVAMENTO = 'dashboard_last_saved_info';

/** Rascunho do questionário guiado: 96 campos que evaporavam num F5. */
export const CHAVE_RASCUNHO_WIZARD = 'dashboard_wizard_rascunho';
export const CHAVE_PASSO_WIZARD = 'dashboard_wizard_passo';

/** De quem é o cache que está nesta máquina. */
export const CHAVE_DONO_CACHE = 'dashboard_cache_owner';

/**
 * Apaga o rascunho do questionário direto no localStorage.
 *
 * Precisa ser chamado por quem CONTINUA montado. O `setState` do Wizard não
 * serve: quando o questionário termina, o dashboard troca de branch e o Wizard
 * desmonta antes de o `useEffect` do `useLocalStorage` gravar — o rascunho
 * sobreviveria, e a próxima visita ofereceria recuperar dados já enviados.
 */
export const descartarRascunhoDoWizard = () => {
  try {
    window.localStorage.removeItem(CHAVE_RASCUNHO_WIZARD);
    window.localStorage.removeItem(CHAVE_PASSO_WIZARD);
  } catch (error) {
    // localStorage indisponível (aba anônima com restrição) — nada a limpar
  }
};

export const CHAVES_DADOS_LOCAIS = [
  CHAVE_DRE,
  CHAVE_BALANCO,
  CHAVE_DASHBOARD,
  CHAVE_ARQUIVOS,
  CHAVE_ULTIMO_SALVAMENTO,
  CHAVE_RASCUNHO_WIZARD,
  CHAVE_PASSO_WIZARD
];
